import addPanelDataConsts, { type AddMenuSection } from '@/addPanelDataConsts';
import superAppsConstants from '../../superApps/superAppsConstants';
import * as service from './service';

const appDefinitionId = superAppsConstants.MEMBERS_STAFF_WIDGET.APP_DEF_ID;
const widgetId = superAppsConstants.MEMBERS_STAFF_WIDGET.WIDGET;

const onClick = service.onClickFactory(appDefinitionId, widgetId);
const onDrop = service.onDropFactory(appDefinitionId, widgetId);

const getSection = function (): AddMenuSection {
  return {
    type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
    hide: false,
    title: 'add_section_label_staffwidget',
    subNavigationTitle: 'add_section_label_staffwidget',
    presetTitle: 'add_section_label_staffwidget',
    tooltipTitle: 'add_section_header_staffwidget_tooltip_title',
    sectionName: 'staffWidgetSection',
    subNavigationHide: false,
    showSectionHeader: true,
    additionalBehaviours: {
      labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
      infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
      hoverImageAction: addPanelDataConsts.HOVER_IMAGE_ACTIONS.SCALE,
      iconEnabledForComps: {},
    },
    props: {
      image:
        'addPanelData/sections/membersStaffWidgetSection_en/membersStaffWidgetSection_en.png',
      onClick,
      onDrop,
      items: [
        {
          id: 'Staff_Widget_1',
          structure: {
            type: 'Component',
            layout: {
              x: 0,
              y: 0,
              fixedPosition: false,
              width: 980,
              height: 670,
              scale: 1,
              rotationInDegrees: 0,
            },
            skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
            componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
            data: {
              type: 'WidgetRef',
              appDefinitionId,
              widgetId,
              originVertical: appDefinitionId,
              metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false,
              },
              scopedPresets: {
                desktop: {
                  layout: 'variants-l4r5atwd',
                  style: 'variants-l4r5atwd',
                },
                mobile: {
                  layout: 'variants-kuwcdv8s',
                  style: 'variants-kuwcdv8s',
                },
              },
            },
            style: '',
            activeModes: {},
          },
          preset: { rect: { width: 324, height: 231, x: 0, y: 0 } },
        },
      ],
    },
    help: {
      hide: false,
      text: 'add_section_header_staffwidget_tooltip_title_description',
    },
  };
};

const registerSection = service.registerSectionFactory(getSection);

export { registerSection };
